import {Repository} from "@api/repositories/Repository";
import {AxiosInstance} from "axios";
import {EventMembership, MembershipsCreateParams} from "../models/EventMemberShip";
import {EventMembershipInterface} from "../models/interfaces/EventMembershipInterface";
import {EventMembershipTypes} from "@api/enums/EventMembershipTypes";
import { Element } from "@api/models/Element";

export class EventMembershipRepository implements Repository {
    client: AxiosInstance;

    constructor(client: AxiosInstance) {
        this.client = client;
    }

    create(data: MembershipsCreateParams) {
        return this.client.post(`/eventMemberships/batch`, data);
    }

    queryParticipants(schema: string, objectIds: string[], types: string[]) {
        const query: any = {};
        if (objectIds) {
            query['objectIds'] = objectIds;
        }
        if (types) {
            query['types'] = types;
        }
        return this.client.post<{[key: string]: EventMembership[]}>(`/eventMemberships/${schema}/participants/query`, query)
            .then(({data}) => {
                for (const objectId in data) {
                    if (Object.prototype.hasOwnProperty.call(data, objectId)) {
                        data[objectId] = data[objectId].map((item: EventMembershipInterface) => new EventMembership(item)) ;
                    }
                }
                return data;
            });
    }

    query(schema: string, objectIds: string[], types: string[]) {
        const query: any = {};
        if (objectIds) {
            query['objectIds'] = objectIds;
        }
        if (types) {
            query['types'] = types;
        }

        return this.client.post<Element[]>(`/eventMemberships/${schema}/query`, query)
            .then(({ data }) => {
                return data.map((item) => new Element(item))
            });
    }

    speakers(schema: string, objectIds: string[]) {
        return this.queryParticipants(schema, objectIds, [EventMembershipTypes.speaker]);
    }

    delete(ids: string[]) {
        return this.client.delete(`/eventMemberships/batch`, {
            data: ids
        });
    }

    registration(schemaId: string, eventId: string) {
        return this.client.post(`/eventMemberships/${schemaId}/${eventId}/registration`);
    }
}